import React from 'react';
import { useSettings } from '../context/SettingsContext';
import PresetSelector from '../components/settings/PresetSelector';
import StrategySettings from '../components/settings/StrategySettings';
import RiskSettings from '../components/settings/RiskSettings';
import NotificationSettings from '../components/settings/NotificationSettings';
import ApiSettings from '../components/settings/ApiSettings';
import Button from '../components/common/Button';

const SettingsPage = () => {
  const { resetSettings } = useSettings();

  const handleReset = () => {
    if (window.confirm('모든 설정을 초기화하시겠습니까?\n이 작업은 되돌릴 수 없습니다.')) {
      resetSettings();
      alert('설정이 초기화되었습니다.');
    }
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl sm:text-3xl font-bold">설정</h2>
      </div>

      {/* 설정 프리셋 */}
      <PresetSelector />

      {/* 구분선 */}
      <div className="border-t border-gray-700"></div>

      {/* 거래 전략 설정 */}
      <StrategySettings />

      {/* 구분선 */}
      <div className="border-t border-gray-700"></div>

      {/* 리스크 관리 */}
      <RiskSettings />

      {/* 구분선 */}
      <div className="border-t border-gray-700"></div>

      {/* 알림 설정 */}
      <NotificationSettings />

      {/* 구분선 */}
      <div className="border-t border-gray-700"></div>

      {/* API 연결 */}
      <ApiSettings />

      {/* 구분선 */}
      <div className="border-t border-gray-700"></div>

      {/* 설정 초기화 */}
      <div className="bg-gray-800 rounded-lg p-4 sm:p-6">
        <h3 className="text-lg font-bold text-white mb-3">위험 구역</h3>
        <p className="text-sm text-gray-400 mb-4">
          모든 설정을 기본값으로 되돌립니다. 이 작업은 되돌릴 수 없습니다.
        </p>
        <Button variant="danger" onClick={handleReset}>
          설정 초기화
        </Button>
      </div>
    </div>
  );
};

export default SettingsPage;
